/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  bus
} from '../../main';
import {
  mapGetters,
  mapState
} from 'vuex';
export default {
  name: 'section-code-create',
  components: {},
  props: ['topicID'],
  data() {
    return {
      topic: "",
      file: null,
      name: '',
      SectionName: '',
      description: '',
      code_language: '',
      code_snippet: '',
      submitted: false,
      uploadFileName: '',
      uploadFileNameLowercase: '',
      uploadingLoader: false
    }
  },
  computed: {
    ...mapGetters([
      'getsectionbycourseIDState',
      'gettopicsdataState'
    ]),
    getCourseSectionDataByID() {
      this.$store.dispatch('update_topic', {
        id: this.topicID
      }).then((res) => {
        this.SectionName = this.$store.getters.gettopicsdataState.data.name;
        this.uploadFileNameLowercase = this.SectionName.toLowerCase();
      }).catch((err) => {})
    }
  },
  mounted() {
    console.log(this.$route.params.id, "Test")
    this.getCourseSectionDataByID
  },
  methods: {
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {
        bus.$emit('HideAddNewCodePopup', false)
      }).catch((err) => {})
    },
    handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.filesSize = this.$refs.file.files[0].size;
        this.name = this.files.name;
        this.uploadFileName = this.files.name
      } else {
        this.uploadFileName = ''
      }
    },
    validateFileBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.uploadingLoader = true
          let formData = new FormData();
          formData.append('topic', this.topicID);
          formData.append('name', this.name);
          formData.append('description', this.description);
          formData.append('code_language', this.code_language);
          formData.append('code_snippet', this.code_snippet);
          formData.append('file', this.files);
          this.$store.dispatch('course_section_file_create', formData)
            .then((res) => {
              if (res.status == '201') {
                this.uploadingLoader = false
                this.getCourseDetailsAgain();
                this.section = '';
                this.name = '';
                this.description = '';
                this.code_snippet = '';
                this.code_language = '';
                this.files = '';
                this.file = null;
                console.log(res.data.data.id)
                toast.success(res.data.msg);
                this.$validator.reset();
              }
            })
            .catch((err) => {
              // toast.error(err.data.msg);
              this.popupCloseFun()
              // debugger
            })
          return
        }
      });
    },
    popupCloseFun() {
      bus.$emit('HideAddNewCodePopup', false)
    },
    resetFileBefore() {
      this.uploadFileName = '';
      this.name = '';
      this.description = '';
      this.code_language = '';
      this.code_snippet = '';
      this.$validator.reset();
    }
  }
}